import clsx from 'clsx';
import React from 'react';

import GiftWrapIcon from '@components/Images/Gift/GiftWrapIcon';

interface GiftPaymentConfirmationProps {
  chargeDate: number;
  isPro: boolean;
  totalCost: number;
}

const GiftPaymentConfirmation = ({
  chargeDate,
  isPro,
  totalCost,
}: GiftPaymentConfirmationProps) => {
  return (
    <div className="flex justify-center">
      <div className="max-w-[644px] flex-col items-center justify-center text-center">
        <GiftWrapIcon
          className={clsx('h-32 w-[66px]', {
            'text-pro-gold': isPro,
            'text-primary-magenta': !isPro,
          })}
        />
        <div className="text-caption-lg text-primary-magenta">Confirmation</div>
        <div className="font-suisse-works text-headline-sm text-black">Your Gift is Sent</div>
        <div className="max-w-[450px]">
          <p>You’re all set.</p>
          <p>
            We’ve charged your card ${(totalCost / 100).toFixed(2)} for your gift subscription The
            Information {isPro ? 'Pro' : 'Annual'} plan.
          </p>
          <p>Card was charged on {chargeDate}.</p>
        </div>
      </div>
    </div>
  );
};

export default GiftPaymentConfirmation;
